import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { withTranslation, Trans } from "react-i18next";
import { Box, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import GlobalNavBar from "../../shared/globalNavBar/GlobalNavBar";
import EMPButton from "../../shared/components/EMPButton/EMPButton";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";
import fordStyles from "./enrollmentRequired.module.scss";
import lincolnStyles from "./enrollmentRequired-Lincoln.module.scss";

const ACCESS_MANAGEMENT_URL = "https://www.accessmgmt.ford.com/aga-home";
const ENROLLMENT_REQUIRED_ROUTE = "/enrollment-required";

const EnrollmentRequired = ({ userDetails, history, t }) => {
  const brand = userDetails?.brand;
  const isFordBrand = IS_FORD_BRAND(brand);
  const styles = isFordBrand ? fordStyles : lincolnStyles;
  const brandName = isFordBrand ? "Ford" : "Lincoln";

  useEffect(() => {
    if (history && history.location?.pathname !== ENROLLMENT_REQUIRED_ROUTE) {
      history.push(ENROLLMENT_REQUIRED_ROUTE);
    }
  }, [history]);

  const navUser = {
    ...userDetails,
    permissions: userDetails?.permissions || {},
  };

  return (
    <Box className={styles.pageWrapper}>
      <GlobalNavBar user={navUser} urlPath="" hideToolbar />

      <Box component="main" className={styles.content}>
        <Typography component="h1" className={styles.programTitle}>
          {t("EnrollmentRequired.programTitle", { brand: brandName })}
        </Typography>
        <Typography component="h2" className={styles.title}>
          {t("EnrollmentRequired.title")}
        </Typography>
        <Typography component="p" className={styles.body}>
          <Trans t={t} i18nKey="EnrollmentRequired.body" />
        </Typography>
        <EMPButton
          testId="set-entitlement-button"
          href={ACCESS_MANAGEMENT_URL}
          target="_blank"
          rel="noopener noreferrer"
          isFordBrand={isFordBrand}
          variant="contained"
          rightIcon={<ArrowForwardIcon fontSize="small" />}
        >
          {t("EnrollmentRequired.button")}
        </EMPButton>
      </Box>
    </Box>
  );
};

EnrollmentRequired.propTypes = {
  userDetails: PropTypes.shape({
    brand: PropTypes.string,
    fullName: PropTypes.string,
    dealerName: PropTypes.string,
    dealerId: PropTypes.string,
    permissions: PropTypes.object,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  t: PropTypes.func.isRequired,
};

EnrollmentRequired.defaultProps = {
  userDetails: {},
  history: undefined,
};

export default withTranslation("emp")(EnrollmentRequired);
